var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChrome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.50278 1.90694C3.82927 0.720967 5.58034 0 7.5 0C10.3784 0 12.8778 1.62097 14.1351 4H7.5C6.0459 4 4.79892 4.88673 4.27029 6.14895L2.50278 1.90694Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.74548 2.68942C0.655856 3.99152 0 5.66907 0 7.5C0 10.8241 2.16179 13.6427 5.15637 14.6267L7.96726 10.9691C7.8144 10.9895 7.65843 11 7.5 11C5.83646 11 4.44398 9.83942 4.08809 8.28377C4.06875 8.25563 4.052 8.22508 4.03835 8.1923L1.74548 2.68942Z",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2149 14.8904C6.63245 14.9624 7.06184 15 7.5 15C11.6426 15 15 11.6426 15 7.5C15 6.62148 14.849 5.77828 14.5715 4.99492C14.5482 4.99827 14.5243 5 14.5 5H9.94949C10.5978 5.63526 11 6.52066 11 7.5C11 8.42321 10.6426 9.26293 10.0585 9.88832C10.0546 9.89383 10.0506 9.89928 10.0465 9.90468L6.2149 14.8904Z",
    fill: "#000000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.5C5 6.11929 6.11929 5 7.5 5C8.88071 5 10 6.11929 10 7.5C10 8.88071 8.88071 10 7.5 10C6.11929 10 5 8.88071 5 7.5Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/chrome.7e2ad3e30820ec5cf678274117760d49.svg";
export { ForwardRef as ReactComponent };